<template>
  <div class="mohu">
    <p class="ysw">以下为您显示“<span style="color: red;">{{homonymName}}</span>”的搜索结果。仍搜索：
    <a :href="linkUrl" style="text-decoration: underline;color: blue;">{{$global.q}}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "CorrectWord",
  props: {
      homonymName: {
          type: String,
          default: ''
      }
  },
  computed: {
      linkUrl() {
          return window.encodeURI(`${window.location.origin}?${this.$global.tab.title}=true&enableHomonyn=false&q=${this.$global.q}`)
      }
  }
};
</script>

<style lang="scss" scoped>
.mohu {
    color: #333333;
    font-size: 14px;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 10px;
    margin-top: 18px;
}</style>
